<template>
    <div class="library-deliverable-table-empty-cell">
        <slot />
    </div>
</template>

<style lang="scss">
@use "@style/variables" as *;

$line-width: 2px;

.library-deliverable-table-empty-cell {
    align-items: center;
    background: repeating-linear-gradient(
        45deg,
        $white,
        $white $line-width,
        $grey1 $line-width,
        $grey1 ($line-width * 2)
    );
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}
</style>
